<template>
  <el-card
    class="h-full"
    :body-style="{ height: '100%', overflowY: 'auto' }"
    v-loading="tableLoading"
  >
    <el-tabs v-model="activeTab" @tab-click="tabClick" class="h-full">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.value"
        :label="item.label"
        :name="item.value"
        class="h-full"
      >
        <div>
          <el-date-picker
            v-model="search.publishTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="发布时间"
            end-placeholder="发布时间"
            class="mr-10px mb-10px"
            value-format="yyyy:MM:dd HH:mm:ss"
          ></el-date-picker>
          <el-date-picker
            v-model="search.creationTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="创建时间"
            end-placeholder="创建时间"
            class="mr-10px mb-10px"
            value-format="yyyy:MM:dd HH:mm:ss"
          ></el-date-picker>
          <el-input
            size="small"
            clearable
            placeholder="作者姓名"
            class="!w-200px mb-10px mr-10px"
            v-model="search.authorName"
            v-if="activeTab === '0'"
          />
          <el-input
            size="small"
            clearable
            placeholder="发布人"
            class="!w-200px mb-10px mr-10px"
            v-model="search.pushUserName"
            v-if="activeTab === '2'"
          />
          <el-input
            size="small"
            clearable
            placeholder="栏目名称"
            class="!w-200px mb-10px mr-10px"
            v-model="search.columnName"
            v-if="activeTab === '3'"
          />
          <el-button size="small" type="primary" @click="searchList">搜索</el-button>
          <el-button size="small" @click="reset">重置</el-button>
          <el-button size="small" @click="download" :disabled="!$hasAccess('export')"
            >导出</el-button
          >
          <el-button size="small" @click="openRulesDialog" v-if="['0', '1'].includes(activeTab)"
            >统计规则设置</el-button
          >
        </div>
        <el-table
          :height="activeTab === '3' ? 'calc(100% - 58px)' : 'calc(100% - 107px)'"
          class="mt-10px"
          :key="activeTab"
          border
          stripe
          :data="tableData"
          :row-key="rowKeyField[activeTab]"
          :ref="`tableRef${item.value}`"
          :tree-props="{ children: 'childItems', hasChildren: 'isLeaf' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column
            v-for="item in tableHead"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="75">
            <template slot-scope="scope">
              <el-button size="mini" :disabled="!$hasAccess('read')" @click="viewDetail(scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="activeTab !== '3'"
          class="text-right mt-20px"
          background
          @size-change="findList"
          @current-change="findList"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          :total="page.pageTotal"
          layout="sizes, total, prev, pager, next, jumper"
          :pager-count="5"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      v-dialogDrag
      title="统计规则设置"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="mini-dialog"
      :append-to-body="true"
    >
      <el-form v-model="form" label-width="190px" label-position="right">
        <template v-if="activeTab === '0'">
          <el-form-item label="同一人为文字/图片/视频作者">
            <el-radio-group v-model="form.sameAuthorDifferentEssayRules">
              <el-radio :label="1">计为1篇</el-radio>
              <el-radio :label="2">计多篇</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="文章多作者">
            <el-radio-group v-model="form.muchAuthorRules">
              <el-radio :label="1">每人记一篇</el-radio>
              <el-radio :label="2">按人数均分</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        <el-form-item label="文章多部门" v-else>
          <el-radio-group v-model="form.muchDepartmentRules">
            <el-radio :label="1">各部门记一篇</el-radio>
            <el-radio :label="2">按部门数均分</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center items-center">
        <el-button type="primary" :loading="saveLoading" @click="save">保存</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      title="查看详情"
      :visible.sync="detailDialog"
      :close-on-click-modal="false"
      class="mid-dialog"
      :append-to-body="true"
    >
      <publish-list
        :type="activeTab"
        :rowData="rowData"
        v-if="showDetailDialog"
        ref="publishList"
      />
    </el-dialog>
  </el-card>
</template>

<script>
import { ManuscriptStatisticsApi, ManuscriptStatisticsRulesApi } from '@wiz-api/workbench'
import { downLoadBlob } from '@/assets/js/CommonDownload'
import dayjs from 'dayjs'

const manuscriptStatisticsApi = new ManuscriptStatisticsApi()
const manuscriptStatisticsRulesApi = new ManuscriptStatisticsRulesApi()
const publishList = () => {
  return import('./PublishList')
}
export default {
  name: 'publishStatistics',
  components: { publishList },
  data() {
    return {
      search: {
        authorName: '',
        pushUserName: '',
        columnName: '',
        publishTime: [],
        creationTime: [],
      },
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      tableLoading: false,
      tabList: [
        { label: '按作者统计', value: '0' },
        { label: '按部门统计', value: '1' },
        { label: '按发布人统计', value: '2' },
        { label: '按栏目统计', value: '3' },
      ],
      activeTab: '0',
      selection: [],
      dialogVisible: false,
      form: {
        muchAuthorRules: 1,
        muchDepartmentRules: 1,
        sameAuthorDifferentEssayRules: 1,
      },
      saveLoading: false,
      detailDialog: false,
      showDetailDialog: false,
      rowKeyField: {
        0: 'authorId',
        1: 'departmentId',
        2: 'pushUserId',
        3: 'id',
      },
    }
  },
  computed: {
    tableHead() {
      if (this.activeTab === '0') {
        return [
          { label: '作者姓名', prop: 'authorName' },
          { label: '发布文章数', prop: 'pushEssayCount' },
        ]
      }
      if (this.activeTab === '1') {
        return [
          { label: '部门', prop: 'departmentName' },
          { label: '发布文章数', prop: 'pushCount' },
        ]
      }
      if (this.activeTab === '2') {
        return [
          { label: '发布人', prop: 'pushUserName' },
          { label: '发布文章数', prop: 'pushCount' },
        ]
      }
      return [
        { label: '栏目名称', prop: 'columnName' },
        { label: '发布文章数', prop: 'pushCount' },
      ]
    },
  },
  methods: {
    viewDetail(row) {
      this.rowData = row
      this.detailDialog = true
      this.showDetailDialog = true
      this.$nextTick(() => {
        this.$refs.publishList.reset()
      })
    },
    tabClick() {
      this.reset()
    },
    getParams() {
      const params = _.pick(this.search, ['authorName', 'pushUserName', 'columnName'])
      if (this.search.publishTime.length) {
        params.pushStartTime = this.search.publishTime[0]
        params.pushEndTime = this.search.publishTime[1]
      }
      if (this.search.creationTime.length) {
        params.createStartTime = this.search.creationTime[0]
        params.createEndTime = this.search.creationTime[0]
      }
      params.skipCount = this.page.pageSize * (this.page.pageNo - 1)
      params.maxResultCount = this.page.pageSize
      return params
    },
    async findList() {
      this.tableLoading = true
      const params = this.getParams()
      let apiResult
      switch (this.activeTab) {
        case '0':
          apiResult = await manuscriptStatisticsApi.getAuthorStatistic(params)
          break
        case '1':
          apiResult = await manuscriptStatisticsApi.getDepartmentStatistic(params)
          break
        case '2':
          apiResult = await manuscriptStatisticsApi.getPushUserStatistic(params)
          break
        default:
          params.maxResultCount = 999
          apiResult = await manuscriptStatisticsApi.getColumnStatistic(params)
          break
      }
      this.tableLoading = false
      if (!apiResult[0]) {
        this.tableData = apiResult[1].items
        this.page.total = apiResult[1].totalCount
      }
    },
    searchList() {
      this.$refs[`tableRef${this.activeTab}`][0].clearSelection()
      this.selection = []
      this.page.pageNo = 1
      this.findList()
    },
    reset() {
      this.search = this.$options.data().search
      this.searchList()
    },
    async download() {
      const params = {
        body: this.getParams(),
        returnType: 'Blob',
      }
      let apiResult
      switch (this.activeTab) {
        case '0':
          params.body.names = _.map(this.selection, (item) => {
            return item.authorType === 1 ? item.authorName : item.authorId
          })
          apiResult = await manuscriptStatisticsApi.manuscriptAuthorExport(params)
          break
        case '1':
          params.body.departmentNames = _.map(this.selection, 'departmentId')
          apiResult = await manuscriptStatisticsApi.manuscriptDepartmentExport(params)
          break
        case '2':
          params.body.userIds = _.map(this.selection, 'pushUserId')
          apiResult = await manuscriptStatisticsApi.manuscriptPushUserExport(params)
          break
        default:
          params.body.maxResultCount = 999
          params.body.columnIds = _.map(this.selection, 'id')
          apiResult = await manuscriptStatisticsApi.manuscriptColumnExport(params)
          break
      }
      if (apiResult && !apiResult[0]) {
        downLoadBlob({
          name: `发布统计导出${dayjs().format('YYYYMMDDHHmmss')}.xlsx`,
          data: apiResult[1],
        })
      }
    },
    handleSelectionChange(selection) {
      this.selection = selection
    },
    async openRulesDialog() {
      const [err, res] = await manuscriptStatisticsRulesApi.getRules()
      if (!err) {
        this.form = _.pick(res, [
          'muchAuthorRules',
          'muchDepartmentRules',
          'sameAuthorDifferentEssayRules',
        ])
      }
      this.dialogVisible = true
    },
    async save() {
      this.saveLoading = true
      const [err] = await manuscriptStatisticsRulesApi.create({
        body: this.form,
      })
      this.saveLoading = false
      if (!err) {
        this.$message.success('保存成功')
        this.dialogVisible = false
      }
    },
  },
  created() {
    this.findList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 55px);
}
</style>
